import { forwardRef } from "@angular/core"
import { TitleLangDirective } from "./utils/title-lang.directive"
import {
	Icon,
	PostIconComponent,
	PreIconComponent,
	Spin,
	SpinnerComponent,
	TabClickDirective,
} from "./utils/utils.component"

export const COMMON_IMPORTS = [
	TitleLangDirective,
	forwardRef(() => Icon),
	forwardRef(() => Spin),
	forwardRef(() => SpinnerComponent),
	forwardRef(() => PreIconComponent),
	forwardRef(() => PostIconComponent),
	forwardRef(() => TabClickDirective),
]
